import React from "react";
import { Modal, Button, Typography } from "antd";
import { ExclamationCircleOutlined, FileSearchOutlined } from "@ant-design/icons";
import { useAtom } from "jotai";
import { useHistory } from "react-router-dom";
import {
	visibleModalConsentimientoDatosAtom,
	documentoConsentimientoAtom,
	formularioSeleccionadoAtom,
} from "pages/v3/mis-pendientes/componentes/MisDocumentosMovil/MisDocumentosMovilStorage";

const { Title, Paragraph, Text } = Typography;

export function ModalConsentimientoDatosMovil() {
	const history = useHistory();
	const [visible, setVisible] = useAtom(visibleModalConsentimientoDatosAtom);
	const [documento] = useAtom(documentoConsentimientoAtom);
	const [, setFormularioSeleccionado] = useAtom(formularioSeleccionadoAtom);

	const onClickRevisar = () => {
		if (!documento) return;
		setFormularioSeleccionado(documento);
		setVisible(false);
		history.push(`/v3/mis-pendientes/visor-formulario-pdf/${documento.formularioId}/${documento.id}`);
	};

	return (
		<Modal
			open={visible}
			closable={false}
			footer={null}
			centered
			width={460}
			destroyOnClose
		>
			<div style={{ textAlign: "center", padding: "8px 0 20px" }}>
				<ExclamationCircleOutlined
					style={{ fontSize: 48, color: "#faad14", marginBottom: 16 }}
				/>
				<Title level={4} style={{ marginBottom: 8 }}>
					Consentimiento Pendiente
				</Title>
				<Paragraph type="secondary" style={{ marginBottom: 20 }}>
					Tiene un documento pendiente de revisión:
				</Paragraph>
				<div
					style={{
						background: "#fffbe6",
						border: "1px solid #ffe58f",
						borderRadius: 6,
						padding: "10px 16px",
						marginBottom: 20,
					}}
				>
					<Text strong style={{ fontSize: 13 }}>
						{documento?.nombreDocumento}
					</Text>
				</div>
				<Paragraph type="secondary" style={{ marginBottom: 24, fontSize: 13 }}>
					Debe leer el documento completo antes de aceptar o rechazar el
					consentimiento para el uso de sus datos personales e imagen.
				</Paragraph>
				<Button
					type="primary"
					size="large"
					icon={<FileSearchOutlined />}
					onClick={onClickRevisar}
					style={{ width: "100%" }}
				>
					Revisar Documento para Decidir
				</Button>
			</div>
		</Modal>
	);
}
